var map = {
	"./angpao.webp": 2299,
	"./bonus.webp": 2300,
	"./gpi-rebate-m.webp": 2301,
	"./gpi-rebate.webp": 2302,
	"./hublot-watch-2018.webp": 2303,
	"./hublot-watch-2022.webp": 2304,
	"./iphone-13-pro-max.webp": 2305,
	"./iphone-14-pro-max.webp": 2306,
	"./login-to-m.webp": 2307,
	"./login-to.webp": 2308,
	"./mb.webp": 2309,
	"./mg-rebate-m.webp": 2310,
	"./mg-rebate.webp": 2311,
	"./np.webp": 2312,
	"./pointer.webp": 2313,
	"./pp-rebate-m.webp": 2314,
	"./pp-rebate.webp": 2315,
	"./sadface.webp": 2316,
	"./wallet-m.webp": 2317,
	"./wallet.webp": 2318,
	"./wheel-b.webp": 2319,
	"./wheel-btn.webp": 2320,
	"./wheel-indon-b.webp": 2321,
	"./wheel-indon.webp": 2322,
	"./wheel.webp": 2323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 928;